var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUpArrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 6,
    viewBox: "0 0 14 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.53084 0.195434C7.53839 0.202634 7.54142 0.212234 7.54898 0.219434L12.8262 4.84797C13.121 5.10837 13.121 5.53079 12.8262 5.79119C12.8232 5.79359 12.8202 5.79479 12.8171 5.79599C12.7515 5.85905 12.6694 5.90998 12.5765 5.94521C12.4835 5.98045 12.382 5.99915 12.279 6H1.72302C1.61813 5.99865 1.51489 5.97904 1.42059 5.94255C1.32629 5.90605 1.24324 5.85356 1.17731 5.78879L1.17428 5.79119C1.03163 5.66017 0.953125 5.49277 0.953125 5.31958C0.953125 5.1464 1.03163 4.97899 1.17428 4.84797L6.4636 0.195434C6.52945 0.134159 6.61126 0.0849543 6.70338 0.0512137C6.79551 0.0174732 6.89576 0 6.99722 0C7.09868 0 7.19893 0.0174732 7.29105 0.0512137C7.38318 0.0849543 7.46499 0.134159 7.53084 0.195434Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpArrow);
export default __webpack_public_path__ + "static/media/upArrow.44a1f356a9b36eaf7d258aeabad87168.svg";
export { ForwardRef as ReactComponent };